/// <amd-module name="Wit/Portal/Redux/WorkItemPortalModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IWorkItemPortalAwareState } from "./WorkItemPortalContracts";
import { workItemPortalReducer } from "./WorkItemPortalReducers";
import { workItemPortalSaga } from "./WorkItemPortalSaga";

export function getWorkItemPortalModule(): [ISagaModule<IWorkItemPortalAwareState>] {
    return [
        {
            id: "work-item-portal",
            reducerMap: {
                workItemPortalState: workItemPortalReducer
            },
            sagas: [workItemPortalSaga]
        }
    ];
}
